export default "__VITE_ASSET__Dbe1ou0u__"